import React, { useEffect, useState, useContext, useRef } from 'react'
import { Table, Button, Popover, Input, Row, Col, Divider, message } from 'antd'
import { MoreOutlined } from '@ant-design/icons/lib/icons'
import { useReactToPrint } from 'react-to-print'
import { ticketPageStyle, printContinuousTicket } from '../../../../utils/ticketPrintStyle'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import Utils from '../../../../utils/Utils'
import SellsListModal from './SellsListModal'
import PosSrc from '../../PosSrc'
import { Context, useStore } from '../../../../context'
import { useHistory } from 'react-router'
import { VentaTicketFactura } from '../sell/VentaTicketFactura'

const { Search } = Input

function SellsListIndex(props) {
  const [state, dispatch] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const [loading, setLoading] = useState(false)
  const [nextPage, setNextPage] = useState('')
  const [dataSource, setDataSource] = useState([])
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [visible, setVisible] = useState(false)
  const [infoRow, setInfoRow] = useState({})
  const [flag, setFlag] = useState(false)
  const [total, setTotal] = useState(0)
  const [getSell, setGetSell] = useState({})
  const [allTurnos, setAllTurnos] = useState(true)

  const history = useHistory()

  useEffect(() => {
    if (props.activeKey === '4') {
      fetchSellsList(props.store.id)
    }
    // eslint-disable-next-line
  }, [props.activeKey])

  // eslint-disable-next-line
  useEffect(() => { if (componentRef.current) handlePrint() }, [flag])

  const componentRef = useRef();
  const printWidthMm = getSell?.store?.ticket_print_width === '3' ? 80 : 58
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: ticketPageStyle,
    print: printContinuousTicket,
  })

  const colorStatus = (text) => {
    switch (text) {
      case 'Paid':
        return 'var(--tendero-green)'

      case 'Cancelled':
        return 'red'

      default:
        return 'grey'
    }
  }

  const columns = [
    {
      title: 'Factura/Ticket',
      dataIndex: 'invoice', // Field that is goint to be rendered
      render: text => <span style={{ textAlign: 'left' }}>{text}</span>,
    },
    {
      title: 'Fecha',
      dataIndex: 'date', // Field that is goint to be rendered
      render: text => <span>{`${text}hrs`}</span>,
    },
    {
      title: 'Monto',
      dataIndex: 'total', // Field that is goint to be rendered
      render: text => <span>{Utils.formatNumber(Number(text))}</span>,
    },
    {
      title: 'Status',
      dataIndex: 'status', // Field that is goint to be rendered
      render: text => <span style={{ color: colorStatus(text) }}>{text}</span>,
    },
    {
      title: 'Tipo',
      dataIndex: 'type', // Field that is goint to be rendered
      render: text => <span>{text}</span>,
    },
    {
      align: 'right',
      title: '',
      dataIndex: 'key', // Field that is goint to be rendered
      render: (id, data) => {
        const isCertified = data.status_dte === 'CERTIFIED'

        return (
        <span>
          {((hasPermissions([48]) && isCertified) || data.status !== 'Cancelled') && (
            <Popover
              placement="left"
              content={
                <div>
                  {hasPermissions([48]) && (
                    <>
                      {data.status !== 'Cancelled' && !data.project_id && !data.quote_id &&
                        <>
                          <span className={'user-options-items'} onClick={() => onDelete(data)}>
                            {isCertified ? 'Anular factura' : 'Anular ticket'}
                          </span>
                          {isCertified && <Divider className={'divider-enterprise-margins'} type={'horizontal'} />}
                        </>
                      }
                    </>
                  )}
                  {isCertified && (
                    <span className={'user-options-items'} onClick={() => facturaToPrint(data)}>
                      Ver factura
                    </span>
                  )}

                  {data.status !== 'Cancelled' && !data.project_id && !data.quote_id &&
                    <>
                      <Divider className={'divider-enterprise-margins'} type={'horizontal'} />
                    </>
                  }

                  {data.status !== 'Cancelled' &&
                    <>
                      <span className={'user-options-items'} onClick={() => ticketToPrint(1, data)}>
                        Ver ticket
                      </span>
                    </>
                  }

                </div>
              }
              trigger="click"
            >
              <Button shape={'circle'} className={'enterprise-settings-button'}>
                <MoreOutlined />
              </Button>
            </Popover>
          )}
        </span>
      )},
    },
  ]

  const fetchSellsList = async (storeId, filter = '') => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(filter)
    let getSells = null

    try {
      if (!allTurnos) {
        getSells = await PosSrc.getSellsAllTurns(storeId, state.turn.id, filter, excludeChars, 'desc')
      } else {
        getSells = await PosSrc.getSells(storeId, state.turn.id, filter, excludeChars, 'desc')
      }

      const response = getSells

      setDataSource(setSells(response))
      setExistMoreInfo(response.data.next_page_url !== null)
      setNextPage(response.data.next_page_url)
      setLoading(false)
    } catch (err) {
      console.log(err)
      message.error('Error al cargar las ventas')
      setLoading(false)
    }
  }

  const setSells = sells => {
    if (sells !== 'Too Many Attempts.') {
      let _sells = sells.data.data || []

      return _sells.map((d, i) => ({
        key: i,
        id: d.id,
        date: Utils.formatDateTime(new Date(d.date)),
        dateAux: Utils.formatDateTime(new Date(d.date)),
        total: d.total,
        invoice: d.status_dte === 'CERTIFIED' || d.status_dte === 'CANCELLED' ? `Factura: ${d.sell_invoice.invoice}` : `Ticket: ${d.sell_invoice.invoice}`,
        payment_method: d.sell_payment?.payment_method?.name,
        status: Utils.jsUcfirst(d.status),
        status_dte: d.status_dte,
        allow_fel: d.sell_invoice?.company?.allow_fel,
        company: d.sell_invoice?.company?.name,
        nit: d.sell_invoice?.company?.nit,
        address: d.sell_invoice?.company?.address,
        store_turn_id: d.store_turn_id,
        project_id: d.project_id,
        quote_id: d.quote_id,
        type: d.project_id ? 'Proyecto' : d.quote_id ? 'Cotización' : 'Venta'
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const onSearch = searchText => {
    fetchSellsList(props.store.id, searchText)
  }

  const onDelete = data => {
    if (visible) {
      setLoading(true)
      PosSrc.sellDelete(infoRow.id)
        .then(res => {
          if (res?.errors && Object.keys(res.errors)?.length > 0) {
            setLoading(false)
            checkErrors(res)
          } else {
            message.success('Se ha eliminado la venta')
            getCash(res.store_id)
            setVisible(false)
          }
        })
        .catch(err => {
          console.log(err)
          message.error('Error al eliminar la venta')
          setLoading(false)
        })
    } else {
      setVisible(true)
      setInfoRow(data)
    }
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      return message.error(res.errors[key])
    })
  }

  const getCash = id => {
    PosSrc.getStoreCash(id).then(response => {
      dispatch({
        type: 'TURN CASH',
        payload: response.data[0],
      })
      fetchSellsList(props.store.id)
    })
  }

  const handlerMoreButton = () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)
      PosSrc.getNextPage(nextPage).then(response => {
        setDataSource(dataSource.concat(setSells(response)))
        setExistMoreInfo(response.data.next_page_url !== null)
        setNextPage(response.data.next_page_url)
        setLoading(false)
      })
    }
  }

  const facturaToPrint = async (sellShow) => {
    // Se abre la pestaña ya, de forma síncrona con el click, para que el
    // navegador no la bloquee como popup; la URL real se setea al llegar.
    const invoiceWindow = window.open('', '_blank')

    try {
      const response = await PosSrc.getInvoiceDocumentUrl(sellShow.id)
      if (response?.url) {
        invoiceWindow.location.href = response.url
      } else {
        invoiceWindow.close()
        message.error('No se pudo obtener el documento de la factura')
      }
    } catch (err) {
      console.log(err)
      invoiceWindow.close()
      message.error('No se pudo obtener el documento de la factura')
    }
  }

  const ticketToPrint = async (key, sellShow) => {
    let getSell = null

    try {
      console.log("por llamar el api, ");
      
      getSell = await PosSrc.getSell(sellShow.id)
    } catch (err) {
      console.log(err)
      history.go(0)
      return false
    }

    console.log("estos son los datos del api ", getSell);
    
    setGetSell(getSell)
    setTotal(key)
    setFlag(!flag)
  }

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <VentaTicketFactura ref={componentRef} getSell={getSell} />
      default:
        break;
    }
  }

  return (
    <>
      <h4 className={'section-space-list-bottom'}>Lista de ventas</h4>
      {/* fuera de pantalla pero medible (no display:none) para calcular la altura real antes de imprimir */}
      <div style={{ position: 'fixed', top: 0, left: '-99999px', visibility: 'hidden', width: `${printWidthMm}mm` }}>{returnPrint(total)}</div>
      <Row gutter={16}>
        <Col xs={19} sm={19} md={19} lg={19}>
          <Search placeholder="Buscar por número de factura" className={'tendero-table-search custom-search'} size={'large'} onSearch={onSearch} />
        </Col>
        <Col xs={5} sm={5} md={5} lg={5}>
          <Button className={allTurnos ? 'not-turnos new-deposit' : 'pay-receivable new-deposit'} onClick={() => setAllTurnos(!allTurnos)}>
            {allTurnos ? 'Turno actual' : 'Todos los turnos'}
          </Button>
        </Col>
      </Row>
      <Table
        className={'CustomTableClass'}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        loading={loading}
        rowKey={(record, index) => index}
      />
      <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
      <SellsListModal visible={visible} onDelete={onDelete} visibleStatus={status => setVisible(status)} />
    </>
  )
}

export default SellsListIndex
